import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Partner {
  id: number;
  name: string;
  logo: string;
}

export function Partners() {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);

  const partners: Partner[] = [
    { id: 1, name: "Marie Claire", logo: "/img/GMC.svg" },
    { id: 2, name: "Prisma", logo: "/img/prisma.svg" },
    { id: 3, name: "Webedia", logo: "/img/webedia.svg" },
    { id: 4, name: "Azerion", logo: "/img/azerion2.svg" },
    { id: 5, name: "Lad Bible", logo: "/img/LadBible.svg" },
    { id: 6, name: "Reworld", logo: "/img/reworld.svg" },
    { id: 7, name: "Times Internet", logo: "/img/TimesInternet.svg" },
    { id: 8, name: "Yahoo", logo: "/img/yahoo.svg" },
    { id: 9, name: "Fandom", logo: "/img/fandom.svg" },
    { id: 10, name: "Media Net", logo: "/img/mediaNet.svg" },
    { id: 11, name: "Freestar", logo: "/img/freestar4.svg" },
    { id: 12, name: "Washington Post", logo: "/img/WP.svg" },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % partners.length);
    }, 3000);
    return () => clearInterval(timer);
  }, [partners.length]);

  return (
    <section className="py-12 bg-white dark:bg-black">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-4">
          <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
            {t('partners.title')}
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300">
            {t('partners.subtitle')}
          </p>
        </div>

        <div className="relative overflow-hidden w-full h-[500px]">
          <div className="absolute inset-0 flex justify-center items-center">
            <div className="relative w-full max-w-6xl">
              {partners.map((partner, index) => {
                const position = ((index - activeIndex + partners.length) % partners.length);
                
                const configs = {
                  0: { x: '-100%', z: '0px', opacity: 1, scale: 1 },
                  1: { x: '0%', z: '0px', opacity: 1, scale: 1 },
                  2: { x: '100%', z: '0px', opacity: 1, scale: 1 },
                  default: { x: '200%', z: '-200px', opacity: 0, scale: 0.8 }
                };

                const config = configs[position as keyof typeof configs] || configs.default;

                return (
                  <div
                    key={partner.id}
                    className="absolute top-1/2 left-1/2 w-[300px] -translate-y-1/2 transition-all duration-700 ease-in-out"
                    style={{
                      transform: `translateX(${config.x}) translateZ(${config.z}) scale(${config.scale})`,
                      opacity: config.opacity,
                    }}
                  >
                    <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg h-[400px] flex flex-col items-center justify-center">
                      <div className="h-[280px] w-full flex items-center justify-center p-4">
                        <img
                          src={partner.logo}
                          alt={partner.name}
                          className="max-h-full max-w-full object-contain dark:invert dark:brightness-0"
                        />
                      </div>
                      <h3 className="text-xl font-semibold text-gray-900 dark:text-white text-center mt-4">
                        {partner.name}
                      </h3>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="flex justify-center space-x-4 mt-8">
          <button
            onClick={() => setActiveIndex((prev) => (prev - 1 + partners.length) % partners.length)}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            ←
          </button>
          <button
            onClick={() => setActiveIndex((prev) => (prev + 1) % partners.length)}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            →
          </button>
        </div>
      </div>
    </section>
  );
}